var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import SupplierService from '../../../api/SupplierService';
import AddDialog from './AddDialog.vue';
import CategoryDialog from './CategoryDialog.vue';
import GlobalVue from "../../../globalVue";
import PurchasePrice from '../../../page/basicArchives/PurchasePrice.vue';
import ArticleList from "../../../components/alert/ArticleList.vue";
import ImportData from "../../../components/dataActions/ImportData.vue";
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.keywords = '';
        _this.addNextStepDgVisible = false;
        return _this;
    }
    BillHeader.prototype.created = function () {
        this.service = SupplierService.getInstance();
    };
    BillHeader.prototype.getList = function () {
        this.$emit('fresh-tree');
        this.$emit('search');
    };
    BillHeader.prototype.add = function () {
        var _this = this;
        if (!this.listData.length) {
            this.$message.warning('请先添加供应商类别');
            return;
        }
        var instance = this.$dialog(AddDialog, {}, {
            title: "添加供应商",
            width: 640,
            height: 600
        }).instance;
        instance.$on("save:ok", function () {
            _this.$emit('search');
            _this.addNextStepDgVisible = true;
            setTimeout(function () {
                _this.addNextStepDgVisible = false;
            }, 3000);
        });
    };
    BillHeader.prototype.search = function () {
        this.$emit('keywords-change', this.keywords);
    };
    BillHeader.prototype.exportData = function () {
        console.log('------exportData');
        this.$emit('export-data', this.keywords);
    };
    BillHeader.prototype.category = function () {
        var _this = this;
        var instance = this.$dialog(CategoryDialog, {
            data: {},
        }, {
            title: "类别管理",
            width: 760,
            height: 440
        }).instance;
        instance.$on("fresh-tree", function (data) {
            _this.$emit('fresh-tree', data);
            _this.$emit('search');
        });
    };
    BillHeader.prototype.disEnable = function (status) {
        var _this = this;
        var filterRows = this.selectRows.filter(function (item) { return item.status == status; });
        if (!this.selectRows.length) {
            this.$message.error("请选择供应商");
            return;
        }
        else if (filterRows.length > 0) {
            this.$message.error(status == 0 ? "有效状态供应商方可停用" : "无效状态供应商方可启用");
            return;
        }
        ;
        var supplier_upper_ids = this.selectRows.map(function (item) { return item.supplier_upper_id; }).join(',');
        this.service.disEnable({ supplier_upper_ids: supplier_upper_ids, status: status }).then(function (res) {
            if (res.data.code == 0) {
                _this.$message.success("操作成功");
                _this.$emit('search');
                return;
            }
            var instance = _this.$dialog(ArticleList, {
                data: {
                    resData: res.data,
                    sureButtonText: '知道了'
                }
            }, {
                title: "提示",
                width: 450,
                height: 350
            }).instance;
            instance.$on("addClient:ok", function (data) {
            });
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    BillHeader.prototype.importData = function () {
        this.$refs.ImportData.showImportModal();
    };
    BillHeader.prototype.getCategoryId = function () {
        return this.selectRows.map(function (item) { return item.supplier_upper_id; }).join(',');
    };
    BillHeader.prototype.addNext = function () {
        this.addNextStepDgVisible = false;
        GlobalVue.$emit('addTab', {
            component: PurchasePrice,
            title: '采购价格',
            showExist: true,
            name: 'purchase-price',
            cprops: {}
        });
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], BillHeader.prototype, "selectRows", void 0);
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], BillHeader.prototype, "listData", void 0);
    BillHeader = __decorate([
        Component({
            components: {
                'import-data': ImportData,
            },
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
